import styled from "styled-components";
import { FormControl, Select, InputLabel, TextField, MenuItem } from '@mui/material';
import { useGetInoutHistSel, useGetInoutSel } from "../../../interface/inout";

import React, { useState, useEffect } from 'react';
import CommonDataGrid from "../../common/CommonDataGrid";
import moment from 'moment';

import { useQuery } from "react-query";
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NaviText from "../../backoffice/common/NaviText";
import { useGetInspectHistSel, useGetInspectSel } from "../../../interface/inspect";
import { Row } from "../../../styles/common";
import Button from "../../common/Button";
import Tab from '../inout/Tab';
import { ISP_TP } from "../../common/constants";

const MainWrap = styled.div`
    width: 100%;
    // padding: 1rem;
    display: flex;
    gap: 0.8rem;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .subTab {
        // padding: 1rem 0rem;
        width: 100%;
        display: flex;
        gap: 0.8rem;
        align-items: center;
        justify-content: flex-start;
    }
    .pannel {
        margin: 1rem 1rem 0rem 1rem;
        width: calc(100% - 2rem);
    }
    .gridPannel {
        margin: 0rem 1rem 0rem 1rem;
        width: calc(100% - 2rem);
        overflow:auto;
    }
`;

const columns = [
    { field: 'tno', headerName: '자산번호', width: 120 },
    { field: 'cat_nm', headerName: '분류', width: 100 },
    { field: 'lot_no', headerName: '표기번호', width: 100 },
    { field: 'ret_stnm', headerName: '조사상태', width: 80 },
    { field: 'model_nm', headerName: '모델명', width:140 },
];

const MInspectMain = (props) => {

    const param = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [naviText, setNaviTest] = useState();
    const [sno, setSno] = useState((location.state && location.state.sno) ? parseInt(location.state.sno,10) : -1);
    const [inspectInfo, setInspectInfo] = useState({});

    const {data : { tabId } } = useQuery('TAB',{initialData:{tabId:0}});
    const {data: inspectList } = useGetInspectSel({isp_tp:param.isp_tp});
    const { data, isLoading, refetch: inspectHistRefetch } = useGetInspectHistSel({sno:sno});
    

    const [list, setList] = useState([]);

    useEffect(()=>{
        switch(param.isp_tp){
            case ISP_TP.NORMAL:
                setNaviTest('정기조사(반기)');
                break;
            case ISP_TP.MONTH:
                setNaviTest('월간조사(월간)');
                break;
            case ISP_TP.TERM:
                setNaviTest('수시조사(임시)');
                break;
            default :
                setNaviTest('전체')
                break;
        }
    },[param.isp_tp])

    useEffect(()=>{
        setInspectInfo(inspectList && inspectList.find(item=>item.sno === sno));
        inspectHistRefetch();
    },[sno, inspectList])

    useEffect(()=>{
        if(data){
            setList(
                data.map((item,index)=>(
                    {
                        ...item,
                        id: index,
                        o_reg_dt: moment(item.o_reg_dt).format('YYYY/MM/DD HH:mm'),
                        i_reg_dt: (item.i_reg_dt && item.i_reg_dt!== null) ? moment(item.i_reg_dt).format('YYYY/MM/DD HH:mm') : '',
                    }
                    )));
        }else{
            setList([])
        }
    },[data])

    return (
        <MainWrap>
            <div style={{marginBottom:'-1rem',padding:'0 1rem'}}>
                <NaviText target={[{text:'HOME',url:'/'}, {text:naviText}]} />
            </div>
            <div className="pannel" style={{marginTop:0}}>
                <FormControl style={{width:'100%'}} size='small'>
                    <InputLabel id='ispNm-label'>작업명</InputLabel>
                    <Select label="작업명" labelId='ispNm-label' size='small' value={sno} >
                        {inspectList && inspectList.map((item,index)=>{
                            return <MenuItem 
                                        key={index} 
                                        value={item.sno} 
                                        onClick={()=>setSno(item.sno)}
                                    >
                                        {item.isp_nm}
                                    </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>
            {inspectInfo &&
                <React.Fragment>
                    <Tab />
                    {tabId ===0 && 
                    <div className='pannel' style={{marginTop:0}}>
                        <Row style={{display:'grid',width:'100%',gap:'8px',gridTemplateColumns:'1fr 1fr 1fr'}}>
                            <TextField
                                id='ist_tpnm'
                                label='조사유형'
                                size='small'
                                disabled={true}
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inspectInfo && inspectInfo.isp_tpnm}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='reg_dt'
                                label='등록자'
                                size='small'
                                disabled
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inspectInfo && inspectInfo.reg_nm}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='reg_dt'
                                label='등록일'
                                size='small'
                                disabled
                                // type='date'
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inspectInfo && moment(inspectInfo.reg_dt).format('YYYY-MM-DD')}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </Row>
                        <Row>
                            <TextField
                                id='contents' 
                                label='조사내용' 
                                fullWidth 
                                multiline 
                                disabled
                                rows={2} 
                                size='small' 
                                value={inspectInfo && inspectInfo.contents}
                            />
                        </Row>
                        <Row>
                            <TextField
                                id='descr' 
                                label='비고' 
                                fullWidth 
                                multiline
                                disabled 
                                rows={2} 
                                size='small' 
                                value={inspectInfo && inspectInfo.descr}
                            />
                        </Row>
                    </div>
                    }
                    {tabId === 1 &&
                        <div className="gridPannel">
                            <Row>
                                전체 : {list.length}
                            </Row>
                        <CommonDataGrid
                            isLoading={isLoading}
                            list={list}
                            columns={columns}
                            // showCount={30}
                            autoHeight={true}
                            // onRowClick={(e)=>{setTargetSelect(e.row);setItemOpen(true)}}
                        />
                        </div>
                    }
                        <Button style={{margin:'0 1rem',width:'calc(100% - 2rem)'}} onClick={()=>navigate('/inspect/add/'+inspectInfo.sno)}>조사<img src={'/images/ic_qrcode.svg'}  alt='' /></Button>
                </React.Fragment>
            }
        </MainWrap>
    )
}

export default MInspectMain;